let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8RXo7")).then(() => parcelRequire('bdn6P'));